var slickOptions = new function () {
    this.productCarousel = function ($el) {
        return {
            slidesToShow: 9,
            slidesToScroll: 9,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1232,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }
            ]
        };
    };
    this.caseStudies = function ($el) {
        return {
            dots: false,
            infinite: false,
            arrows: true,
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 1232,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        };
    };
    this.productPanel = function ($el) {
        var options = {
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true,
            responsive: []
        };
        if ($el.children().length == 3 || $el.children().length == 4) {
            options.responsive.push({
                breakpoint: 9999,
                settings: 'unslick'
            });
        }
        options.responsive.push({
            breakpoint: 1231,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        });
        options.responsive.push({
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        });
        options.responsive.push({
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false
            }
        });
        return options;
    };
    this.newProducts = function ($el) {
        var options = {
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true,
            responsive: []
        };
        if ($el.children().length == 4) {
            options.responsive.push({
                breakpoint: 9999,
                settings: 'unslick'
            });
        }
        options.responsive.push({
            breakpoint: 1432,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        });
        options.responsive.push({
            breakpoint: 1231,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        });
        options.responsive.push({
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        });
        options.responsive.push({
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false
            }
        });
        return options;
    };
    this.productGallery = function ($el) {
        return {
            slidesToShow: 6,
            slidesToScroll: 6,
            infinite: false,
            arrows: true,
            vertical: true,
            responsive: [{
                    breakpoint: 1432,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 6,
                    }
                },
                {
                    breakpoint: 1232,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        vertical: false,
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        vertical: false,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        vertical: false,
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        vertical: false,
                    }
                },
                {
                    breakpoint: 394,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        vertical: false,
                    }
                }
            ]
        };
    };
    this.insightsPopular = function ($el) {
        return {
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true,
            responsive: [{
                    breakpoint: 1231,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        dots: true,
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };
    };
};
//data.doInitialiseSlickCarousels();